module.exports = __webpack_public_path__ + "media/workplace/edit-icon-1aaebd07.svg";